import React from 'react'
import { SVGProps } from 'react'

const ChevronNextIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.5334 11.4689C3.82603 11.7621 4.30103 11.7621 4.59374 11.469L8.817 7.24C9.14407 6.91139 9.32768 6.46663 9.32768 6.003C9.32768 5.53937 9.14407 5.09461 8.817 4.766L4.58824 0.531015C4.29556 0.237908 3.82055 0.238014 3.528 0.531252C3.23624 0.823707 3.23635 1.29718 3.52826 1.58949L7.759 5.826C7.80587 5.87288 7.8322 5.93646 7.8322 6.00275C7.8322 6.06904 7.80587 6.13262 7.759 6.1795L3.53357 10.4103C3.24151 10.7027 3.24144 11.1764 3.5334 11.4689Z" />
  </svg>
)
export default ChevronNextIcon
